import React from "react";
import { Link } from "react-router-dom";
import { Animate } from "react-simple-animate";
import Footer from "../../../footer";
import About from "../about";
import Contact from "../contact";
import Portfolio from "../portfolio";
import Resume from "../resume";
import Skills from "../skills";
import "./styles.scss";

const Home = () => {

  return (
    <>
      <section className="home" id="home">
        <div className="home__text-wrapper">
          <h1>
            Hello, I'm Uhai Mong
            <br />
            Front End Developer
          </h1>
        </div>
        <Animate
          play
          duration={1.5}
          delay={1}
          start={{
            transform: "translateY(550px)",
          }}
          end={{
            transform: "translateX(0px)",
          }}
        >
          <div className="home__contact-me">
            <Link className="button" to="https://forms.gle/4RTUq1eUTaK8yDcx9" target="_blank">Hire Me</Link>
          </div>
        </Animate>
      </section>
      <About />
      <Resume />
      <Skills />
      <Portfolio />
      <Contact />
      <Footer/>
    </>
  );
};

export default Home;
